import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addToWatchlist } from "./watchlistActions";

const DateTimePicker = ({ movie, onClose }) => {
  const dispatch = useDispatch();
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [time, setTime] = useState("20:00");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (date && time) {
      dispatch(addToWatchlist(movie, date, time));
      onClose();
    }
  };

  return (
    <div className="picker-backdrop" onClick={onClose}>
      <div className="picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <h5>
            <i className="fas fa-calendar-plus mr-2"></i>
            Plan to Watch
          </h5>
          <button className="picker-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="picker-body">
          <div className="picker-movie-info">
            <img
              src={
                movie.Poster && movie.Poster !== "N/A"
                  ? movie.Poster
                  : "https://via.placeholder.com/60x90"
              }
              alt=""
              className="picker-thumb"
            />
            <div>
              <strong>{movie.Title}</strong>
              <br />
              <small className="text-muted">{movie.Year}</small>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                className="form-control"
                value={date}
                min={today}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Time</label>
              <input
                type="time"
                className="form-control"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block">
              <i className="fas fa-check mr-1"></i> Add to Watch List
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DateTimePicker;
